export const COMPANY_ROUTES = {
  COMPANY: '/empresa',
  UNITS: '/unidades',
  GOALS: '/metas',
  WHATSAPP: '/whatsapp',
} as const;

export const COMPANY_ENDPOINTS = {
  ME: '/api/v1/companies/me',
  UNITS: '/api/v1/units',
  GOALS: '/api/v1/companies/goals',
  HOURS: '/api/v1/companies/me/hours',
  unit: (id: string) => `/api/v1/units/${id}`,
} as const;

export const COMPANY_QUERY_KEYS = {
  me: ['company', 'me'] as const,
  units: ['company', 'units'] as const,
  goals: ['company', 'goals'] as const,
  hours: ['company', 'hours'] as const,
};
